import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Printers } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class PrinterService extends TmsWebBaseEditService<Printers, Printers> {
  constructor() {
    super('Printer', $localize`Printers`);
  }
  getDocument(documentName: string): Observable<Printers> {
    return this.httpService.get<Printers>(`${this.apiUrl}/GetDocument?documentName=${documentName}`);
  }

  getAllExternalDocuments(): Observable<Printers[]> {
    return this.httpService.get<Printers[]>(`${this.apiUrl}/GetAllExternalDocuments`);
  }
}
